// ConfirmChangeRuleDialog.tsx
import { Button } from '@/app/common/components/button/Button.tsx'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogClose,
} from '@/shad/ui/dialog'

export function ConfirmChangeRuleDialog({
  open,
  onOpenChange,
  onConfirm,
}: {
  open: boolean
  onOpenChange: (next: boolean) => void
  onConfirm: () => void
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Are you sure you want to change the rule?</DialogTitle>
          <DialogDescription>
            Rule changes will take effect immediately across the system.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="sm:justify-end">
          <DialogClose asChild>
            <Button type="button" variant="outline">
              Cancel
            </Button>
          </DialogClose>
          <Button
            type="button"
            variant="primary"
            onClick={() => {
              onConfirm()
              onOpenChange(false)
            }}
          >
            Change Rule
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
